module.exports = __webpack_public_path__ + "2f5d3c5ceca1d3268b15ee8cb8c823e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/email_folder_2x.png
// module id = 105
// module chunks = 0 1 2 3 4